import { INVOICE_FILE } from "../constants";

// Reglas puras del archivo adjunto de factura. Sin React ni estado: entra el
// archivo, sale un booleano. Estaban triplicadas en los tres diálogos de carga.

/**
 * Forma mínima que necesitan estas reglas. Los diálogos pasan un `File` real; los
 * tests pasan objetos literales (`{ type: ... }`, `{ size: ... }`) sin construir un
 * `File` completo, así que el tipo se queda en la intersección que ambos satisfacen.
 */
interface InvoiceFileCandidate {
  type?: string;
  size?: number;
}

/** El tipo MIME del archivo está dentro de los aceptados (.pdf / .docx). */
export const isAllowedInvoiceFileType = (file: InvoiceFileCandidate | null | undefined): boolean =>
  INVOICE_FILE.ALLOWED_MIME_TYPES.includes(file?.type ?? "");

/** El archivo no supera el tamaño máximo (el tope exacto se acepta). */
export const isWithinInvoiceFileSize = (file: InvoiceFileCandidate | null | undefined): boolean =>
  (file?.size ?? 0) <= INVOICE_FILE.MAX_SIZE_BYTES;
